import { DNI_LETTERS } from './documentoIdentidadUtils.js';

// Solo Espana valida digito de control; el resto de paises solo regex.
const CIF_LETTERS = 'JABCDEFGHI';
const CIF_TYPES = 'ABCDEFGHJNPQRSUVW';

// Espana — isDNI (DNI 8+letra)
function isDNI(value) {
  if (!/^\d{8}[A-Z]$/.test(value)) return false;
  const n = Number(value.slice(0, 8));
  return DNI_LETTERS[n % 23] === value[8];
}

// Espana — isNIE (NIE X/Y/Z+7+letra)
function isNIE(value) {
  if (!/^[XYZ]\d{7}[A-Z]$/.test(value)) return false;
  const map = { X: '0', Y: '1', Z: '2' };
  const n = Number(map[value[0]] + value.slice(1, 8));
  return DNI_LETTERS[n % 23] === value[8];
}

// Espana — isCIF (CIF fiscal empresa)
function isCIF(value) {
  const compact = String(value)
    .trim()
    .toUpperCase()
    .replace(/[\s./-]/g, '');
  if (!/^[A-Z]\d{7}[A-Z0-9]$/.test(compact)) return false;
  if (!CIF_TYPES.includes(compact[0])) return false;
  const body = compact.slice(1, 8);
  const sum = [...body].reduce((total, char, index) => {
    const digit = Number(char);
    if (index % 2 === 1) return total + digit;
    const doubled = digit * 2;
    return total + (doubled > 9 ? doubled - 9 : doubled);
  }, 0);
  const control = (10 - (sum % 10)) % 10;
  const check = compact[8];
  return check === String(control) || check === CIF_LETTERS[control];
}

const VALIDATORS = {
  isDNI,
  isNIE,
  isCIF,
};

export function validateWithValidator(name, value) {
  const fn = VALIDATORS[name];
  if (!fn) return true;
  return Boolean(fn(value));
}
